import React from "react";
import { Approvers, CopyValue, Disclosure, LabelValue, Violations } from "../..";
import { StampToDate } from "../../../Utils/utils";
import StatusIndicator from "../Components/status";
import EmployeeInfo from "../../Cards/EmployeeInfo";
import { useClientSettings } from "Hooks/useClientSettings";
import { approvalQueueCopy } from "../../../Utils/approvalRuleCopy";

function RequestDetails({
	id,
	date,
	amount,
	requestor,
	approvers,
	violations,
	type,
	status,
	request,
	trail,
	inSequence,
	steps,
	appliedPolicy,
	showViolations = true,
	showRequestDetails = true,
	showRequestedBy = true,
	showApprovers = true,
}) {
	const { currency } = useClientSettings();
	const progress = status === "pending" ? approvalQueueCopy(trail, inSequence) : null;

	return (
		<>
			{showRequestDetails ? (
				<div className="p-4 rounded-lg shadow-sm bg-canvas">
					<Disclosure defaultOpen={true} heading={<h4>Request Details</h4>}>
						<div className="grid grid-cols-1 gap-4 mt-4 sm:grid-cols-2">
							<LabelValue label="Request ID">
								<CopyValue>APP-{id}</CopyValue>
							</LabelValue>
							<LabelValue label="Requested on">{StampToDate(date)}</LabelValue>
							<LabelValue label="Requested Amount">
								{currency} {amount}
							</LabelValue>
							<LabelValue label="Request Status">
								<StatusIndicator status={status} label={progress?.badge} />
							</LabelValue>
						</div>
					</Disclosure>
				</div>
			) : null}
			{showRequestedBy ? (
				<div className="p-4 rounded-lg shadow-sm bg-canvas">
					<Disclosure defaultOpen={true} heading={<h4>Requested By</h4>}>
						<EmployeeInfo employee={requestor} className="mt-2" />
					</Disclosure>
				</div>
			) : null}
			{showApprovers ? (
				<div className="p-4 rounded-lg shadow-sm bg-canvas">
					<Disclosure defaultOpen={true} heading={<h4>Approvers</h4>}>
						<Approvers approvers={approvers} steps={steps} inSequence={inSequence} appliedPolicy={appliedPolicy} />
					</Disclosure>
				</div>
			) : null}
			{showViolations ? <Violations violations={violations} /> : null}
		</>
	);
}

export default RequestDetails;
